// TODO: replace all references with CSS divide
export default function Divider() {
  return <hr className="border-outline" />;
}
